<template>
    <app-layout :display-mode="displayMode">
        <Head>
            <title>Dashboard</title>
        </Head>

        <template v-slot:overline>
            <translate>Willkommen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <template v-slot:produceroptions>
            <div>
                <form-button icon="column-artboard" @click="toggleViewMode" v-if="displayMode === 'tabs'">
                    <translate>Cockpit Ansicht</translate>
                </form-button>
                <form-button icon="slides-windows" @click="toggleViewMode" v-if="displayMode === 'cockpit'">
                    <translate>Tab Ansicht</translate>
                </form-button>
            </div>
        </template>

        <div class="dashboard" v-if="displayMode === 'tabs'">
            <div class="row">
                <div class="col col-6">
                    <div class="dashboard--tabs">
                        <nav>
                            <ul>
                                <li>
                                    <dashboard-tab icon="user-profile-square" :active="currentCard[0]" @click="toggleCard(0)" :count="countNewOrders">
                                        <translate>unbestätigte<br/>Aufträge</translate>
                                    </dashboard-tab>
                                </li>
                                <li>
                                    <dashboard-tab icon="user-profile-square" :active="currentCard[1]" @click="toggleCard(1)" :count="countRunningOrders">
                                        <translate>laufende<br/>Aufträge</translate>
                                    </dashboard-tab>
                                </li>
                                <li>
                                    <dashboard-tab icon="user-profile-square" :active="currentCard[2]" @click="toggleCard(2)" :count="countNewQuotes">
                                        <translate>neue<br/>Anfragen</translate>
                                    </dashboard-tab>
                                </li>
                                <li>
                                    <dashboard-tab icon="user-profile-square" :active="currentCard[3]" @click="toggleCard(3)" :count="countEeditableOffers">
                                        <translate>editierbare<br/>Angebote</translate>
                                    </dashboard-tab>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div class="col col-6 col--align-center col--justify-end">
                    <div class="dashboard--ranking">
                        <card minify="true">
                            <card-content>
                                <description-group>
                                    <description-element :title="this.$gettext('Pünktlichkeit')" :caption="this.$page.props.user.punctuality_rate" leading="true" is-percentage="true" />
                                    <description-element :title="this.$gettext('Anfragenbearbeitung')" :caption="this.$page.props.user.activity_rate" leading="true" is-percentage="true" />
                                </description-group>
                            </card-content>
                        </card>
                        <card minify="true">
                            <card-content>
                                <description-group>
                                    <description-element :title="this.$gettext('Wareneingang')" :caption="this.$page.props.user.quality_rate" leading="true" is-percentage="true" />
                                    <description-element :title="this.$gettext('Reklamationsrate')" :caption="this.$page.props.user.complaint_rate" leading="true" is-percentage="true" />
                                </description-group>
                            </card-content>
                        </card>
                    </div>
                </div>
            </div>
            <div class="dashboard--content">
                <dashboard-new-orders :new-orders="newOrders" v-if="currentCard[0]"/>

                <dashboard-running-orders :running-orders="runningOrders" v-if="currentCard[1]"/>

                <dashboard-new-quotes :new-quotes="newQuotes" v-if="currentCard[2]" :abilities="abilities"/>

                <dashboard-editable-offers :editable-offers="editableOffers" v-if="currentCard[3]"/>
            </div>
        </div>

        <div class="dashboard" v-if="displayMode === 'cockpit'">
            <div class="dashboard--ranking">
                <card minify="true">
                    <card-content>
                        <description-element :title="this.$gettext('Pünktlichkeit')" :caption="this.$page.props.user.punctuality_rate" leading="true" is-percentage="true"/>
                    </card-content>
                </card>
                <card minify="true">
                    <card-content>
                        <description-element :title="this.$gettext('Anfragenbearbeitung')" :caption="this.$page.props.user.activity_rate" leading="true" is-percentage="true"/>
                    </card-content>
                </card>
                <card minify="true">
                    <card-content>
                        <description-element :title="this.$gettext('Wareneingang')" :caption="this.$page.props.user.quality_rate" leading="true" is-percentage="true"/>
                    </card-content>
                </card>
                <card minify="true">
                    <card-content>
                        <description-element :title="this.$gettext('Reklamationsrate')" :caption="this.$page.props.user.complaint_rate" leading="true" is-percentage="true"/>
                    </card-content>
                </card>
            </div>
            <div class="dashboard--cockpit">
                <div class="row">
                    <div class="col col-6">
                        <div class="row">
                            <div class="col">
                                <content-toggle toggle="unbestätigte Aufträge" is-toggled="true">
                                    <dashboard-new-orders :new-orders="newOrders" minified="minified"/>
                                </content-toggle>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <content-toggle toggle="laufende Aufträge" is-toggled="true">
                                    <dashboard-running-orders :running-orders="runningOrders" minified="minified"/>
                                </content-toggle>
                            </div>
                        </div>
                    </div>
                    <div class="col col-6">
                        <div class="row">
                            <div class="col">
                                <content-toggle toggle="Anfragen" is-toggled="true">
                                    <dashboard-new-quotes :new-quotes="newQuotes" :abilities="abilities"
                                                          minified="minified"/>
                                </content-toggle>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <content-toggle toggle="editierbare Angebote" is-toggled="true">
                                    <dashboard-editable-offers :editable-offers="editableOffers" minified="minified"/>
                                </content-toggle>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>

</template>
<script>

import AppLayout from '@partfactory/Layouts/AppLayout';
import {Head} from '@inertiajs/vue3';

import DashboardRunningOrders from '@partfactory/Pages/Producer/Dashboard/DashboardRunningOrders';
import DashboardNewQuotes from '@partfactory/Pages/Producer/Dashboard/DashboardNewQuotes';
import DashboardEditableOffers from '@partfactory/Pages/Producer/Dashboard/DashboardEditableOffers';
import DashboardNewOrders from '@partfactory/Pages/Producer/Dashboard/DashboardNewOrders';
import DashboardTab from '@partfactory/Pages/Client/Dashboard/DashboardTab';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ContentToggle from '@partfactory/Shared/Elements/ContentToggle';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';

export default {
    name: 'ProducerDashboard',
    components: {
        DescriptionGroup,
        DescriptionElement,
        CardContent,
        Card,
        ContentToggle,
        FormButton,
        DashboardTab,
        DashboardNewOrders,
        DashboardEditableOffers,
        DashboardNewQuotes,
        DashboardRunningOrders,
        AppLayout,
        Head,
    },
    props: {
        newOrders: Object,
        newQuotes: Object,
        editableOffers: Object,
        runningOrders: Object,
        abilities: Object,
    },
    data() {
        return {
            currentCard: {
                0: true,
                1: false,
                2: false,
                3: false
            },
            displayMode: 'tabs',
        };
    },
    created() {
        const cardIndex = this.$page.props?.vueSettings?.card_index;
        if (cardIndex) this.toggleCard(cardIndex);

        const displayMode = this.$page.props?.vueSettings?.display_mode;
        if (displayMode) this.displayMode = displayMode;
    },
    computed: {
        countNewOrders() {
            return this.newOrders.length;
        },
        countRunningOrders() {
            return this.runningOrders.length;
        },
        countNewQuotes() {
            return this.newQuotes.length;
        },
        countEeditableOffers() {
            return this.editableOffers.length;
        },
    },
    methods: {
        toggleCard(cardIndex) {
            this.$inertia.post(this.$$route('vue-settings'), {
                _token: this.$page.props.csrf_token,
                card_index: cardIndex,
            });

            return Object.keys(this.currentCard).map((card, index) => {
                this.currentCard[index] = index === cardIndex;
            });

        },
        toggleViewMode() {
            this.displayMode = this.displayMode === 'tabs' ? 'cockpit' : 'tabs';

            this.$inertia.post(this.$$route('vue-settings'), {
                _token: this.$page.props.csrf_token,
                display_mode: this.displayMode,
            });

        },
    },
};
</script>
